var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"login-slideshow"},_vm._l((this.slideCount),function(n){return _c('transition',{key:n,attrs:{"name":"slide"}},[(_vm.currentSlide == n)?_c('li',{staticClass:"slide",class:_vm.slideClass(n)}):_vm._e()])}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8203eeda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/HomeSlideshow.vue
// module id = ci24
// module chunks = 0